export default (function (date) {
  return Math.floor(date.getTime() / 1000);
});